module.exports = __webpack_public_path__ + "site/img/213.18ebf668.jpg";